module.exports = __webpack_public_path__ + "static/muteSign-8af294f4992aa676b9cb80b9e31ef06f.png";